import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AtomicNameAndAvatarComponent } from '../../private/abstract-components/atomic/atomic.name-avatar.component';
import {
  AVATAR_PLACEHOLDER_TEXT,
  DEFAULT_AVATAR_COLOR,
} from '../../private/config';
import {
  AtomicComponentType,
  ExpandedAvatarStyles,
} from '../../private/utils/types.private';
import { TranslatedNameService } from '../services/translated-name-service';

/**
 * Example usage:
 * ```html
<plugins-user-avatar [userProvider]="providedUser" />
<plugins-user-avatar [userId]="id" />
<plugins-user-avatar [userId]="id" [size]="25px" />
``` */
@Component({
  selector: 'plugins-user-avatar',
  standalone: false,
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
  providers: [TranslatedNameService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent extends AtomicNameAndAvatarComponent {
  labelBackgrounds = [DEFAULT_AVATAR_COLOR];
  placeholderText = AVATAR_PLACEHOLDER_TEXT;
  declare generatedStyles: ExpandedAvatarStyles;
  override componentType: AtomicComponentType = 'userAvatar';

  avatarLabelBackground(): { backgroundColor: string } {
    return { backgroundColor: this.labelBackgrounds[0] };
  }
}
